<template>
  <scrollview class="Messages" ref="messages">
    <transition-group name="message" tag="div" class="messages">
      <div class="message" v-for="message in messages" :key="message.key" :class="{ success: message.extend.calc && message.extend.calc.result === true, failed: message.extend.calc && message.extend.calc.result === false }">
        <div class="head">
          <figure v-if="get(message.from)" @click="reply(message.from)" class="icon"><img :src="src(get(message.from).imageKey)" alt=""></figure>
          <figure v-for="to in message.to" :key="to" v-if="get(to)" @click="reply(to)" class="icon to"><img :src="src(get(to).imageKey)" alt=""></figure>
          <p v-if="get(message.from)" class="name">{{get(message.from).name}}</p>
        </div>
        <div class="body">
          <p class="text">
            <span class="str">{{message.text}}</span>
            <span v-if="message.extend.calc">
              <span class="dice" v-for="(d, i) in message.extend.calc.dice" :key="i" v-text="d"></span>
              <span class="result" v-text="result(message.extend.calc.result)"></span>
            </span>
          </p>
        </div>
      </div>
    </transition-group>
  </scrollview>
</template>

<script>
export default {
  updated: function () {
    this.$nextTick(() => {
      this.$refs.messages.scrollTop = 0 // reverse
      // this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
    })
  },
  methods: {
    result(res) {
      if (res === true) {
        return '成功'
      }
      if (res === false) {
        return '失敗'
      }
      return res
    },
    reply(key) {
      const character = this.get(key)
      if (character) {
        this.$store.commit('local/addToList', key)
      }
    }
  },
  computed: {
    messages() {
      return this.$store.getters['messages/$items'].filter((message) => {
        const toAll = !message.to || message.to === '*' // todo: remove
        const toMe = Array.isArray(message.to) && (message.to.includes(this.characterKey) || message.to.length === 0)
        const fromMe = message.from === this.characterKey
        return toAll || toMe || fromMe
      })
      // const { messagesChannel } = this.$data.state
      // switch (messagesChannel) {
      //   case 'all':
      //     return this.$store
      //   default:
      //     return this.$data.messages.toArray().slice(-3)
      // }
    },
    get() {
      return this.$store.getters['characters/$get']
    },
    src() {
      return this.$store.getters['images/getSrc']
    },
    characterKey() {
      return this.$store.getters['local/currentCharacterKey']
    }
  }
}
</script>

<style scoped>
.Messages {
  box-sizing: border-box;
  padding: 10px;
  width: 25%;
  /*z-index: 10000;*/
  /* overflow: scroll; */
  max-height: 100%;
  position: absolute;
  top: 0;
  right: 0;
}
.messages {
  display: flex;
  flex-flow: column-reverse nowrap;
}
.message {
  margin-bottom: 4px;
  padding: 7px;
  position: relative;
  /* background: #30353E; */
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
}
.message.failed {
  color: #fff;
  background: rgba(215, 0, 0, 0.4);
  /* background: #F17F98; */
}
.message.success {
  color: #fff;
  background: rgba(0, 215, 0, 0.4);
  /* background: #3ED783; */
}
.head {
  margin-bottom: 5px;
  position: relative;
  display: flex;
  align-items: center;
}
.icon {
  padding: 1px;
  border-radius: 50%;
  overflow: hidden;
  width: 20px;
  height: 20px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  cursor: pointer;
}
.name {
  margin-left: 5px;
  font-size: 12px;
  font-weight: 800;
  word-break: break-all;
  flex: 1;
}
.to {
  margin-left: -4px;
  z-index: 0;
}
.body {
  font-size: 12px;
}
.body p {
  word-break: break-all;
}
.body p .str {
  margin-right: 4px;
}
.body p .dice {
  margin-right: 4px;
  padding: 2px 4px;
  border-radius: 2px;
  display: inline-block;
  line-height: 1;
  background: #fff;
  color: #444;
  font-size: 10px;
  font-weight: 800;
  text-align: center;
}
.body p .result {
  padding: 2px 4px;
  border-radius: 2px;
  display: inline-block;
  background: #444;
  line-height: 1;
  font-size: 10px;
  font-weight: 800;
  text-align: center;
}
.body p .result::before {
  margin-right: 2px;
  content: ">>";
  color: #888;
}
.message-enter-active {
  transition: all 0.4s 0.1s;
  transform: scale(1);
}
.message-enter {
  transform: scale(0.95);
  opacity: 0;
}
.message-leave-active {
  /* transition: all 0.4s 10s; */
  transition: all 0.4s 0.1s;
  transform: scale(0.95);
  opacity: 0;
}
.message-leave {
  transform: scale(1);
}
</style>
